import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

const base_url = process.env.REACT_APP_API_URL;

const DepositHistory = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [recharge, setRecharge] = useState([]);
  const [filteredRecharge, setFilteredRecharge] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [filters, setFilters] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    minAmount: "",
    maxAmount: "",
    status: "all",
  });

  console.log("filter reachege", filteredRecharge)

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const openImageModal = (imageUrl) => {
    setSelectedImage(imageUrl);
    setShowImageModal(true);
  };

  const closeImageModal = () => {
    setShowImageModal(false);
    setSelectedImage(null);
  };

  function formateT(param) {
    return param < 10 ? "0" + param : param;
  }

  function timerJoin(params = "", addHours = 0) {
    let date = params ? new Date(Number(params)) : new Date();
    date.setHours(date.getHours() + addHours);
    const years = formateT(date.getFullYear());
    const months = formateT(date.getMonth() + 1);
    const days = formateT(date.getDate());
    const hours = date.getHours() % 12 || 12;
    const ampm = date.getHours() < 12 ? "AM" : "PM";
    const minutes = formateT(date.getMinutes());
    const seconds = formateT(date.getSeconds());

    return `${years}-${months}-${days} ${hours}:${minutes}:${seconds} ${ampm}`;
  }

  const withdrawData = async () => {
    try {
      const auth = localStorage.getItem("admin");
      const response = await axios.post(
        base_url + "/api/webapi/admin/recharge",
        { auth },
        { headers: { "content-type": "application/json" } }
      );
      const data = response?.data.datas2;
      if (response?.data.status) {
        setRecharge(data);
        setFilteredRecharge(data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    withdrawData();
  }, [refresh]);

  const applyFilters = () => {
    const {
      search,
      fromDate,
      toDate,
      minAmount,
      maxAmount,
      status,
    } = filters;

    const from = fromDate ? new Date(fromDate).getTime() : null;
    const to = toDate ? new Date(toDate).getTime() : null;

    const filtered = recharge.filter((item) => {
      const itemTime = Number(item.time);
      const itemAmount = Number(item.money);
      const phone = String(item.phone || "");
      const idOrder = String(item.id_order || "");
      const utr = String(item.utr || "");
      const bankOrUpiName = String(item.bankOrUpiName || "");


      if (
        search &&
        !phone.includes(search) &&
        !idOrder.includes(search) &&
        !utr.includes(search)&&
        !bankOrUpiName.includes(search)

      ) return false;

      if (from && itemTime < from) return false;
      if (to && itemTime > to) return false;
      if (minAmount && itemAmount < Number(minAmount)) return false;
      if (maxAmount && itemAmount > Number(maxAmount)) return false;
      if (status !== "all" && (status === "success" ? item.status !== 1 : item.status === 1)) return false;

      return true;
    });

    setFilteredRecharge(filtered);
  };

  // 🔁 Debounced filter trigger on any filter input change
  useEffect(() => {
    const debounce = setTimeout(() => {
      applyFilters();
    }, 500); // Delay in ms

    return () => clearTimeout(debounce);
  }, [filters, recharge]);

  const countSuccess = filteredRecharge.filter(i => i.status === 1).length;

  // console.log("filterd Recaregs ", filteredRecharge);

  const countRejected = filteredRecharge.filter(i => i.status !== 1).length;

 const totalMoneySuccess = filteredRecharge
  .filter(i => i.money && i.status === 1)
  .reduce((sum, i) => sum + Number(i.money), 0);

  const totalMoneyRejected = filteredRecharge
  .filter(i => i.money && i.status !== 1)
  .reduce((sum, i) => sum + Number(i.money), 0);

  console.log("total" , totalMoneySuccess);
  console.log("total" , totalMoneyRejected);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      
      // On desktop, sidebar should always be "open"
      if (!mobile) {
        setIsSidebarOpen(true);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  return (
    <div className="wrapper">

        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper d-flex flex-column ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <section className="content mt-2">
          <div className="d-flex justify-content-between mt-2 p-1 ">
            <h3 className="px-2">Deposit History</h3>
            <button className="btn btn-primary px-3 m-2" onClick={() => setRefresh(!refresh)}>Refresh</button>
          </div>

          {/* Filters */}
        <div className="row px-2 mb-3 mt-3">
  {/* From Date */}
  <div className="col-md-2">
    <label className="form-label">From Date</label>
    <input
      type="date"
      className="form-control"
      value={filters.fromDate}
      onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
    />
  </div>

  {/* To Date */}
  <div className="col-md-2">
    <label className="form-label">To Date</label>
    <input
      type="date"
      className="form-control"
      value={filters.toDate}
      onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
    />
  </div>

  {/* Min Amount */}
  <div className="col-md-2">
    <label className="form-label">Min Amount</label>
    <input
      type="number"
      className="form-control"
      placeholder="Min Amount"
      value={filters.minAmount}
      onChange={(e) => setFilters({ ...filters, minAmount: e.target.value })}
    />
  </div>

  {/* Max Amount */}
  <div className="col-md-2">
    <label className="form-label">Max Amount</label>
    <input
      type="number"
      className="form-control"
      placeholder="Max Amount"
      value={filters.maxAmount}
      onChange={(e) => setFilters({ ...filters, maxAmount: e.target.value })}
    />
  </div>

  {/* Status Filter */}
 <div className="col-md-4">
  <label className="form-label d-block">Status</label>
  <div className="btn-group" role="group">
    <button
      type="button"
      className={`btn ${filters.status === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
      onClick={() => setFilters({ ...filters, status: 'all' })}
    >
      All
    </button>
    <button
      type="button"
      className={`btn ${filters.status === 'success' ? 'btn-success' : 'btn-outline-success'}`}
      onClick={() => setFilters({ ...filters, status: 'success' })}
    >
      Success
    </button>
    <button
      type="button"
      className={`btn ${filters.status === 'reject' ? 'btn-danger' : 'btn-outline-danger'}`}
      onClick={() => setFilters({ ...filters, status: 'reject' })}
    >
      Reject
    </button>
  </div>
</div>


</div>

{/* Search Bar */}
<div className="input-group px-2 mb-3">
  {/* <label className="form-label me-2 mt-2">Search</label> */}
  <input
    type="text"
    className="form-control"
    placeholder="Search by Account, Transaction ID, or UTR"
    value={filters.search}
    onChange={(e) => setFilters({ ...filters, search: e.target.value })}
  />
</div>


          {/* Totals */}
          <div className="row px-3 mb-2">
            <div className="col">
              <span className="badge bg-success p-2">Total Success: {countSuccess}</span>
            </div>
             <div className="col">
              <span className="badge bg-success p-2">Total Success Amount: {totalMoneySuccess}</span>
            </div>
            <div className="col">
              <span className="badge bg-danger p-2">Total Rejected: {countRejected}</span>
            </div>
            <div className="col">
              <span className="badge bg-danger p-2">Total Rejected Amount: {totalMoneyRejected}</span>
            </div>
          </div>

          {/* Table */}
          <div className="table-responsive px-2">
            <table className="table table-hover table-striped">
              <thead className="bg-dark text-white text-center">
                <tr>
                  <th className="text-light">ID</th>
                  <th className="text-light">Account</th>
                  <th className="text-light">Type</th>
                  <th className="text-light">Account Or UPI</th>

                  <th className="text-light">Amount</th>
                  <th className="text-light">Transaction ID</th>
                  <th className="text-light">UTR</th>
                  <th className="text-light">Proof</th>
                  <th className="text-light">Status</th>
                  <th className="text-light">Recharge Time</th>
                  <th className="text-light">Approval Time</th>

                </tr>
              </thead>
              <tbody className="text-center">
                {filteredRecharge.map((draw) => (
                  <tr key={draw.id}>
                    <td>{draw.id}</td>
                    <td>{draw.phone}</td>
                    <td>{draw.type}</td>
                    <td>{draw.bankOrUpiName}</td>

                    <td>{draw.money}</td>
                    <td>{draw.id_order}</td>
                    <td>{draw.utr || "N/A"}</td>
                    <td>
                      {draw.url ? (
                        <>
                          <img
                            src={`${base_url}${draw.url}`}
                            alt="Proof"
                            style={{ width: "60px", height: "60px", objectFit: "cover", cursor: "pointer", borderRadius: "4px" }}
                            onClick={() => openImageModal(`${base_url}${draw.url}`)} />
                          <br />
                          <small className="text-primary" style={{ cursor: "pointer" }}
                            onClick={() => openImageModal(`${base_url}${draw.url}`)}>View</small>
                        </>
                      ) : "N/A"}
                    </td>
                    <td>
                      <span className={`badge ${draw.status === 1 ? "bg-success" : "bg-danger"}`}>
                        {draw.status === 1 ? "Success" : "Reject"}
                      </span>
                    </td>
                    <td>{draw.time}</td>
                    <td>{draw.approvaltime}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
      </div>

      {/* Image Modal */}
      {showImageModal && (
        <div className="modal fade show" style={{
          display: 'block', backgroundColor: 'rgba(0,0,0,0.5)',
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1050
        }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Payment Proof</h5>
                <button type="button" className="close" onClick={closeImageModal}
                  style={{ background: 'none', border: 'none', fontSize: '1.5rem' }}>
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body text-center">
                <img src={selectedImage} alt="Proof" style={{ maxWidth: '100%', maxHeight: '70vh' }} />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={closeImageModal}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DepositHistory;
